export default __webpack_public_path__ + "static/media/Checklist-white.9d1cb759.svg";